export default __webpack_public_path__ + "static/media/speed-banners-ms.e97c56d5.webp";